import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { SelectItem } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { EngagementManagementService } from '../../../../framework/services/engagement-mgmt.service';
import { IfStmt } from '@angular/compiler';
import { AddEngagementMemoryService } from '../../add-engagement-memory-service/add-engagement-memory.service'
import { element } from 'protractor';
import { Observable, of } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { LanguageService } from 'src/framework/services/language.service';
import { DocumentManagementService } from 'src/framework/services/manage-doc.service';



@Component({
  selector: 'app-basic-details',
  templateUrl: './basic-details.component.html',
  styleUrls: ['./basic-details.component.css']
})
export class BasicDetailsComponent implements OnInit {

  languageBasedRoles = [];
  jurisdictionOption = [];
  engagementLabelModel: EngagementLabelModel;
  engagementDynamicDetails: DynamicDetailsModel[];
  detailsLanguageMapping = [];
  value: Date;
  maxDateValue: Date = new Date();
  selectedLanguageId: number;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;

  engagementDetailsForms: EngagementDetailsForm;
  basicDetailsForm: FormGroup;

  selectedRoleLabelJson: any;
  defaultEngRoleLabelJson: any;
  selectedLangDateJson: any;
  showEditor = false;
  tinyMceConfig: any;
  defaultEngDateJson: any;
  localeSetting: any;
  urlDomain: string = "https://ey.com/ca/";
  yearRange: string;
  @Output() showNextControl = new EventEmitter<string>()
  @Output() showPreviousControl = new EventEmitter<string>();


  constructor(
    private engagementManagementService: EngagementManagementService,
    private addEngagementMemoryService: AddEngagementMemoryService,
    private fb: FormBuilder,
    private manageDocService:DocumentManagementService,
    private languageSerivce: LanguageService,
    private spinner: NgxSpinnerService) {
    this.yearRange = (new Date().getFullYear()) - 20 + ':' + (new Date().getFullYear());
    this.spinner.show();
    this.engagementLabelModel = new EngagementLabelModel("Engagement Name", "EY Role", 'Description');
    this.engagementDetailsForms = new EngagementDetailsForm(new Date(), true, '', false, '', '');
    this.engagementDynamicDetails = new Array<DynamicDetailsModel>();
    let engagementLanguageDetailsForm = [];
    this.languageBasedRoles = this.addEngagementMemoryService.getLanguageBasedRoles();
    this.jurisdictionOption = this.addEngagementMemoryService.getJurisdictionOption();
    let selectedLanguages = this.addEngagementMemoryService.getSelectedLanguages();
    if (selectedLanguages.length > 0) {
      for (let i = 0; i < selectedLanguages.length; i++) {
        let dynamicModel = new DynamicDetailsModel("", "", selectedLanguages[i].name, '', selectedLanguages[i].languageId);
        this.engagementDynamicDetails.push(dynamicModel);
        engagementLanguageDetailsForm.push(this.getEngagementDetailsFormGroup(this.engagementDynamicDetails[i]));
      }
    }
    this.basicDetailsForm = this.fb.group({
      initialDateControl: [this.engagementDetailsForms.IntialDate],
      isConfidentialControl: [false],
      shortURLControl: [this.engagementDetailsForms.ShortUrl, [Validators.maxLength(25), this.validateShortURl()], [this.shortUrlDuplicateValidator()]],
      isFormalControl: [true],
      eyRole: [this.engagementDetailsForms.EYRole, [this.engagementRoleValidation()]],
      jurisdiction: [this.engagementDetailsForms.Jurisdiction, [this.jurisdictionValidation()]],
      engagementLanguageBasedDetails: this.fb.array(engagementLanguageDetailsForm)
    })
    this.spinner.hide();
  }

  ngOnInit() {
    this.configureTinyMce();
    this.loadLanguageLabel();
    
    if (this.addEngagementMemoryService.getEngagementDetails() != null) {
      this.spinner.show();
      this.setEngagementDetails(this.addEngagementMemoryService.getEngagementDetails());
      this.spinner.hide();
    }
  }

  // ngAfterViewInit() {

  // }


  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishLangRoleMappings, selectedLangRoleMappings: any;
    let englishDateMappings, selectedLangDateMappings: any;

    return new Promise((resolve, reject) => {
      this.spinner.show();
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageSerivce.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      });


      this.languageSerivce.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLangRoleMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.UserRole.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDateMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangRoleMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.UserRole.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangRoleMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.UserRole.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangRoleMappings = englishLangRoleMappings;
              selectedLangDateMappings = englishDateMappings;

            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);
          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedRoleLabelJson = JSON.parse(selectedLangRoleMappings?.languageMappingJSON ?? englishLangRoleMappings.languageMappingJSON);
          this.defaultEngRoleLabelJson = JSON.parse(englishLangRoleMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          this.setCalendarLocale();
          this.islabelLoaded = true;
          this.spinner.hide();

         
          resolve(1);
        }
        else {
          this.spinner.hide();
        }
      });
    })
      .catch(err => {
        this.spinner.hide();

        console.log(err);
      });
  }


  RoleReplacer(labelKey): string {
    return this.selectedRoleLabelJson[labelKey]?.trim() ? this.selectedRoleLabelJson[labelKey] ?? 'text not found' : this.defaultEngRoleLabelJson[labelKey] ?? 'text not found';
  }

  
  configureTinyMce() {
    const that = this;
    this.tinyMceConfig = {
      branding: false,
      toolbar_mode: 'sliding',
      toolbar_sticky: false,
      inline: false,
      statusbar: false,
      theme: "silver",
      resize: false,
      skin: "oxide",
      skin_url: 'assets/skins/ui/oxide',
      base_url: '/tinymce',  
      suffix: '.min',
      plugins: [
        "print preview   importcss autoresize searchreplace autolink autosave save directionality  visualblocks visualchars fullscreen image link media  template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists  wordcount   imagetools textpattern noneditable help code charmap  emoticons paste table"],
      menubar: 'edit insert view  format table tools help',
      force_br_newlines: false,
      //force_p_newlines: false,
      //forced_root_block: '',
      // content_css: [
      //   '//fonts.googleapis.com/css?family=EYFontRegular',
      // ],
      paste_as_text: true,
      paste_text_sticky: true,
      font_formats: 'EYFontRegular=EYFontRegular;',
      theme_advanced_fonts: "EYFontRegular=EYFontRegular",
      extended_valid_elements: "@[id|class|title|style|onmouseover|onclick]," +
        "a[name|href=javascript:void(0);|target|title|alt]," +
        "#div,blockquote,-ol,-ul,-li,br,img[src|height|width],-sub,-sup,-b,-i,-u," +
        "-span[data-mce-type],hr,",
      toolbar: 'bold italic backcolor | ' +
        'bullist numlist outdent indent | alignright alignjustify |' +
        '   alignleft aligncenter | removeformat |' +
        ' help '
    };
  }


  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }

  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);
    return shortName;
  }

  setCalendarLocale() {
    this.localeSetting = {
      firstDayOfWeek: 0,
      dayNames: [
        this.calendarReplacer("SUN"),
        this.calendarReplacer("MON"), this.calendarReplacer("TUE"), this.calendarReplacer("WED"),
        this.calendarReplacer("THU"), this.calendarReplacer("FRI"), this.calendarReplacer("SAT")
      ],
      dayNamesShort: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 3), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 3), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 3), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 3)
      ],
      dayNamesMin: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 1), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 1), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 1), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 1)
      ],
      monthNames: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      monthNamesShort: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      today: this.calendarReplacer('TODAY'),
      clear: this.calendarReplacer('CLEAR')
    }
  }

  getEngagementDetailsFormGroup(model: DynamicDetailsModel): FormGroup {
    return this.fb.group({
      engagementName: [model.engagementName, [Validators.required], [this.engagementNameDuplicateValidator()]],
      engagementDescription: [model.descritpion]
    });
  }

  onNextButtonClicked(event, value) {
    if (!this.basicDetailsForm.invalid) {
      this.addEngagementMemoryService.setEngagementDetails(this.engagementDetailsForms.IntialDate, this.engagementDetailsForms.IsFormal,
        this.engagementDetailsForms.ShortUrl, this.engagementDetailsForms.IsConfidential, this.engagementDynamicDetails, this.urlDomain, this.engagementDetailsForms.EYRole, this.engagementDetailsForms.Jurisdiction);
      this.showNextControl.emit(value);
    } else {
      this.basicDetailsForm.markAllAsTouched();
    }
  }

  onPreviousButtonClick(event, value) {
    this.addEngagementMemoryService.setEngagementDetails(this.engagementDetailsForms.IntialDate, this.engagementDetailsForms.IsFormal, this.engagementDetailsForms.ShortUrl, this.engagementDetailsForms.IsConfidential, this.engagementDynamicDetails, this.urlDomain, this.engagementDetailsForms.EYRole, this.engagementDetailsForms.Jurisdiction);
    this.showPreviousControl.emit(value);
  }

  setEngagementDetails(model: any) {
    this.engagementDetailsForms.IntialDate = model.initalDate;
    this.engagementDetailsForms.IsConfidential = model.isConfidential
    this.engagementDetailsForms.IsFormal = model.isPrivate;
    this.engagementDetailsForms.ShortUrl = model.shortUrl;
    this.engagementDetailsForms.EYRole = model.eyRole
    this.engagementDetailsForms.Jurisdiction = model.jurisdiction
    if (model.languageBasedDetails && model.languageBasedDetails.length > 0) {
      this.engagementDynamicDetails.forEach(element => {
        let savedEngagementDetails = model.languageBasedDetails.find(t => t.languageId == element.languageId);
        if (savedEngagementDetails) {
          element.engagementName = savedEngagementDetails.engagementName ? savedEngagementDetails.engagementName : "";
          element.descritpion = savedEngagementDetails.descritpion ? savedEngagementDetails.descritpion : "";
        }
      })
    }
  }

  engagementRoleValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched && control.value && control.value?.engagementRoleId > 0) {
        return null;
      } else if (!control.touched && control.value && control.value?.engagementRoleId > 0) {
        return null;
      }
      return { 'roleRequired': 'Language is required' };
    }
  }


  jurisdictionValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched && control.value && control.value?.jurisdictionOfFilingId > 0) {
        return null;
      } else if (!control.touched && control.value && control.value?.jurisdictionOfFilingId > 0) {
        return null;
      }
      return { 'jurisdictionRequired': 'Jurisdiction is required' };
    }
  }

  validateShortURl(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const url = this.urlDomain.trim() + control.value;
      const URL_REGEXP = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm
      if (control.value != "" && control.valid && !url.match(URL_REGEXP)) {
        return { 'invalidUrl': 'invalid url' }
      }
      return null;
    }
  }

  shortUrlDuplicateValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any | null }> => {
      if ((control.dirty) && control?.value.length > 0) {
        return this.engagementManagementService.findShortUrl(this.urlDomain + control.value);
      }
      return of(null);
    }
  }

  engagementNameDuplicateValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any | null }> => {
      if ((control.dirty) && control?.value.length > 0) {
        return this.engagementManagementService.validateEngagementName(control.value, 0);
      }
      return of(null);
    }
  }
}

export class EngagementLabelModel {
  EngagementName: string;
  EYRole: string;
  Description: string;
  constructor(engagementName: string, eyRole: string, description: string) {
    this.EngagementName = engagementName;
    this.EYRole = eyRole;
    this.Description = description;
  }
}

export class DynamicDetailsModel {
  engagementName: string;
  descritpion: string;
  language: string;
  eyRole: any;
  languageId: number;
  constructor(engagementName: string, descritpion: string, language: string, eyRole: any, languageId: number) {
    this.engagementName = engagementName;
    this.descritpion = descritpion;
    this.language = language;
    this.eyRole = eyRole;
    this.languageId = languageId;
  }
}

export class EngagementDetailsForm {
  IntialDate: Date;
  IsFormal: boolean;
  ShortUrl: string;
  IsConfidential: boolean;
  EYRole: any;
  Jurisdiction: any;
  constructor(intialDate: Date, isFormal: boolean, shortUrl: string, isConfidential: boolean, eyRole: any, jurisdiction: any) {
    this.IntialDate = intialDate;
    this.IsFormal = isFormal;
    this.ShortUrl = shortUrl;
    this.IsConfidential = isConfidential;
    this.EYRole = eyRole;
    this.Jurisdiction = jurisdiction;
  }
}
